/**
 * StageDataNote: outside production, says the Eva usage on this page is this environment's data
 * (SF-5171). An env copy brings company usage over from production; super admin usage is never
 * copied.
 */
import { Alert } from 'antd';
import { APP_ENVIRONMENT } from '../../../config/env';

const MESSAGES = {
  company:
    "Stage data. Company usage up to the last copy from production is production's; everything since is stage's own. Super admin usage is always stage's own.",
  superAdmin: "Stage data. Super admin usage here is stage's own, never copied from production.",
};

export const StageDataNote = ({ usage }: { usage: keyof typeof MESSAGES }) =>
  APP_ENVIRONMENT === 'production' ? null : (
    <Alert type="info" showIcon message={MESSAGES[usage]} />
  );
